<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <card card-body-classes="table-full-width" no-footer-line>
        <h4 class="card-title ml-3" style="margin-top: 0!important; margin-bottom: 0!important;">{{ locale.client_workers }}</h4>
        <br>
        <div class ="d-flex flex-row justify-content-between">
          <div class="d-flex flex-column mb-3 ml-3">
            <span>{{locale.select_client}}: </span>
            <el-select style="z-index: 99999;" v-model="client_id" v-bind:placeholder="locale.select_client"
                       @change="getWorkers()">
              <el-option style="width: 200px"
                         v-for="item in clients"
                         :key="item.client_id"
                         :label="item.name"
                         :value="item.client_id"
              />
            </el-select>
          </div>
          <div class="d-flex flex-column">
            <span>&nbsp;</span>
            <n-button v-if="this.client_id"
                type="primary"
                class="btn btn-sm btn-primary mx-3"
                style="height: 32px;margin-bottom: 0!important;margin-top:0!important; "
                @click.native="onAddworker()"
            >

              <span class="over470">{{ locale.add_worker }}</span>
              <span class="below470">+</span>
            </n-button>
          </div>
        </div>
        <div>
          <el-table stripe style="width: 100%" :data="workers">
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
            >
            </el-table-column>

            <el-table-column :min-width="135" fixed="right" label="Actions">
              <div
                  slot-scope="{ row }"
                  class="table-actions"
                  style="margin-left: 10px"
              >
                <el-tooltip content="Edit" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onEditworker(row.id)"
                      type="info"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons ui-2_settings-90"></i>
                  </n-button>
                </el-tooltip>

                <el-tooltip content="Delete" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onDeleteworker(row.id)"
                      class="remove"
                      type="danger"
                      size="sm"
                      round
                      icon
                  >
                    <i class="fa fa-times"></i>
                  </n-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <modal name="client-worker-form" :adaptive="true" height="auto" :scrollable="true">
          <div style="margin: 1em; margin-top: 3em;">
            <n-button
                @click.native="onModalHide('client-worker-form')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
            <div class="d-flex adaptive-margin  flex-column">
              <div class="adaptive-row adaptive-justify-content">
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.first_name }}:* </span>
                  <input v-model="new_worker_fn">
                </div>
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.last_name }}:* </span>
                  <input v-model="new_worker_ln">
                </div>
              </div>
              <div class="adaptive-row adaptive-justify-content">
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.email }}:* </span>
                  <input v-model="new_worker_email">
                </div>
                <div class="d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.phone }}:* </span>
                  <input v-model="new_worker_phone">
                </div>
              </div>
            </div>
            <div style="text-align: center">
              <n-button v-if="modal_type == 'add'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !checkRequiresOnAdd()}"
                        @click.native="addworker()"
              >
                <span >{{ locale.add_worker }}</span>
              </n-button>
              <n-button v-if="modal_type == 'update'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !checkRequiresOnEdit()}"
                        @click.native="updateworker()"
              >
                <span >{{ locale.update_worker }}</span>
              </n-button>

            </div>
          </div>
        </modal>
<!--        <div slot="footer" class="card-footer d-flex justify-content-end">-->
<!--          <n-pagination v-model="page" @click.native="changePage()" class="pagination-no-border" :total="this.workers.length">-->
<!--          </n-pagination>-->
<!--        </div>-->
      </card>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn, Select, Option} from "element-ui";
// import {Pagination as NPagination} from "src/components";

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  components: {
    // NPagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,

      locale: '',
      total: 0,
      workers: [],
      workersPaged: [],
      client_id: '',
      clients: [],
      tableColumns: [
        {
          prop: "first_name",
          label: this.$getLocale().first_name,
          minWidth: 250,
        },
        {
          prop: "last_name",
          label: this.$getLocale().last_name,
          minWidth: 250,
        },
        {
          prop: "email",
          label: this.$getLocale().email,
          minWidth: 250,
        },
        {
          prop: "phone",
          label: this.$getLocale().phone,
          minWidth: 250,
        },
      ],
      new_worker_fn: '',
      new_worker_ln: '',
      new_worker_pidn: '',
      new_worker_email: '',
      new_worker_phone: '',
      upd_worker_id: '',
      modal_type: '',
    };
  },

  methods: {
    changePage() {
      // this.clientsPaged = this.clients.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    },
    checkRequiresOnAdd() {
      return (this.new_worker_fn && this.new_worker_ln);
    },

    checkRequiresOnEdit() {
      return (this.new_worker_fn && this.new_worker_ln);
    },

    onModalHide(name) {
      this.$modal.hide(name);
    },
    onAddworker() {
      this.new_worker_fn = '';
      this.new_worker_ln = ''
      this.new_worker_pidn = '';
      this.new_worker_email = '';
      this.new_worker_phone = '';
      this.modal_type = 'add';
      this.$modal.show('client-worker-form');
    },

    async addworker() {
      let worker_data = {
        'first_name': this.new_worker_fn,
        'last_name': this.new_worker_ln,
        'personal_id_no': this.new_worker_pidn,
        'email': this.new_worker_email,
        'phone': this.new_worker_phone,
        'id': this.client_id
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(worker_data)
      };
      await fetch(url + "/add-client-worker", requestOptions)
          .then(response => this.getWorkers());
      this.$modal.hide('client-worker-form');
    },

    onEditworker(id) {
      this.upd_worker_id = id;
      let updating_worker = this.workers.filter(elem => elem.id == id)[0];

      this.new_worker_fn = updating_worker.first_name;
      this.new_worker_ln = updating_worker.last_name;
      this.new_worker_pidn = updating_worker.personal_id_no;
      this.new_worker_email = updating_worker.email;
      this.new_worker_phone = updating_worker.phone;

      this.modal_type = 'update';
      this.$modal.show('client-worker-form');
    },

    async updateworker() {
      let worker_data = {
        'first_name': this.new_worker_fn,
        'last_name': this.new_worker_ln,
        'personal_id_no': this.new_worker_pidn,
        'email': this.new_worker_email,
        'phone': this.new_worker_phone,

        'id': this.upd_worker_id
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(worker_data)
      };
      await fetch(url + "/update-client-worker", requestOptions)
          .then(response => this.getWorkers());
      this.$modal.hide('client-worker-form');
    },

    async onDeleteworker(id) {
      let sure = confirm("Are you sure?");
      if (!sure)
        return;
      let worker_data = {
        'id': id,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(worker_data)
      };
      await fetch(url + "/delete-client-worker", requestOptions)
          .then(response => this.getWorkers());
    },

    async getClients() {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'logged_role': this.logged_user_role})
      };
      return await fetch(url + '/list-clients', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }

            this.clients = data;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async getWorkers() {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      fetch(url + '/list-client-workers/' + this.client_id, requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }

            this.workers = data;
            this.changePage();
            this.total = data.length
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    }
  },

  created() {
    this.getClients();
  },
  mounted() {
    this.locale = this.$getLocale();
  },
};
</script>
<style scoped>
.card-body .vm--container {
  z-index: 9999999;
}

.close-modal-btn {
  position: absolute;
  top: 0;
  right: 1%;
}

.vm--container.scrollable::v-deep .vm--modal {
  height: auto !important;
  overflow:hidden!important;
}


.adaptive-row {
  display: flex;
  flex-direction: row;
}

@media (max-width: 600px) {
  .adaptive-row {
    display: flex;
    flex-direction: column;
    /*justify-content: center!important;*/
    align-items: center;
  }
}

.adaptive-row-child-width {
  width: 45%;
  margin-bottom: 1rem;
}

@media (max-width: 600px) {
  .adaptive-row-child-width {
    width: 100%;
    margin-bottom: 1rem;
  }
}


.adaptive-margin {
  margin-left: 1rem;
  margin-right: 1rem;
}

@media (max-width: 600px) {
  .adaptive-margin {
    margin-left: 0;
    margin-right: 0;
  }
}

.w-40 {
  width: 44.5%;
}

select {
  border-radius: 8px;
  background-color: white;
  height: 2rem;
}

input {
  border-radius: 8px;
  border: 1px solid grey;
  height: 2rem;
}

.over470 {
  display: inline;
}
.below470 {
  display: none;
}
@media screen and (max-width: 478px) {
  .over470 {
    display: none;
  }
  .below470 {
    display: inline;
  }
}
.over340 {
  display: inline;
}
.below340 {
  display: none;
}
@media screen and (max-width: 340px) {
  .over340 {
    display: none;
  }
  .below340 {
    display: inline;
  }
}

.adaptive-justify-content {
  justify-content: space-around;
}

@media (max-width: 600px) {
  .adaptive-justify-content {
    justify-content: space-between;
  }
}
</style>